"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3992],{

/***/ 53992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ProjectsIndex_ProjectsIndex; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(85026);
// EXTERNAL MODULE: ./components/StyledRichText/index.tsx + 3 modules
var StyledRichText = __webpack_require__(31585);
// EXTERNAL MODULE: ./components/TinaVideo/TinaVideo.tsx + 1 modules
var TinaVideo = __webpack_require__(4262);
// EXTERNAL MODULE: ./components/TinaAsset/TinaAsset.tsx
var TinaAsset = __webpack_require__(54995);
// EXTERNAL MODULE: ./components/Icons/Icon.tsx + 51 modules
var Icon = __webpack_require__(82218);
;// CONCATENATED MODULE: ./components/ProjectIndexItem/ProjectIndexItem.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid white;\n  padding: 0.5rem 1rem;\n  border-radius: 3rem;\n  display: none;\n  position: absolute;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 1.5rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  border-radius: 1rem;\n  ",
        ";\n  width: 100%;\n  height: 100%;\n  object-position: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: auto;\n  width: ",
        ";\n  height: 100%;\n  object-fit: cover;\n  object-position: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 1.5rem;"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 1.5rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n\n    ",
        "\n\n    ",
        ";\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0.75rem;\n  aspect-ratio: 4 / 3;\n  border-radius: 1rem;\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  display: grid;\n  place-items: center;\n  ",
        ";\n  &:hover ",
        " {\n    display: block;\n    background: transparent;\n    color: white;\n    z-index: 2;\n  }\n\n  &:hover {\n    ::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0.5;\n      background: #000;\n      z-index: 1;\n    }\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 2;\n  &:hover {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: unset;\n  "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0 !important;\n  width: min-content;\n  ",
        "\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n  "
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 85%;\n  ",
        "\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  border-radius: 100%;\n  height: 2.5rem;\n  width: 2.5rem;\n\n  svg {\n    height: 1rem;\n    width: 1.25rem;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}









const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ccdcefe2-0"
})(_templateObject());
const OverlayButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ccdcefe2-1"
})(_templateObject1());
const StyledVideo = (0,styled_components_browser_esm/* default */.ZP)(TinaVideo/* default */.Z).withConfig({
    componentId: "sc-ccdcefe2-2"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject2());
}, (param)=>{
    let { $backgroundPosition  } = param;
    return $backgroundPosition;
});
const StyledAsset = (0,styled_components_browser_esm/* default */.ZP)(TinaAsset/* default */.Z).withConfig({
    componentId: "sc-ccdcefe2-3"
})(_templateObject4(), (param)=>{
    let { $autoWidth  } = param;
    return $autoWidth ? "auto" : "100%";
}, (param)=>{
    let { $backgroundPosition  } = param;
    return $backgroundPosition;
});
const MediaWrapper = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
    componentId: "sc-ccdcefe2-4"
})(_templateObject8(), (param)=>{
    let { theme: { mq  } , $backgroundColor  } = param;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), $backgroundColor, mq.md(_templateObject5()), mq.lg(_templateObject6()));
}, OverlayButton);
const ContentWrapper = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
    componentId: "sc-ccdcefe2-5"
})(_templateObject9());
const TitleLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ccdcefe2-6"
})(_templateObject10(), (param)=>{
    let { theme  } = param;
    return theme.themeColors.fg;
});
const Title = (0,styled_components_browser_esm/* default */.ZP)(FormattedText/* default */.Z).withConfig({
    componentId: "sc-ccdcefe2-7"
})(_templateObject12(), (param)=>{
    let { theme  } = param;
    return theme.mq.lg(_templateObject11());
});
const SubtitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ccdcefe2-8"
})(_templateObject14(), (param)=>{
    let { theme  } = param;
    return theme.mq.lg(_templateObject13());
});
const IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ccdcefe2-9"
})(_templateObject16(), (param)=>{
    let { theme  } = param;
    return theme.themeColors.primary;
}, (param)=>{
    let { theme  } = param;
    return theme.mq.lg(_templateObject15());
});
const ProjectIndexItem = (param)=>{
    let { project  } = param;
    var ref, ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaWrapper, {
                href: (project === null || project === void 0 ? void 0 : project.link) || "",
                $backgroundColor: (project === null || project === void 0 ? void 0 : project.backgroundColor) || "transparent",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayButton, {
                            className: "overlayButton",
                            children: "See the Case Study"
                        }),
                        (project === null || project === void 0 ? void 0 : (ref = project.videoMeta) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledVideo, {
                            src: project === null || project === void 0 ? void 0 : (ref1 = project.videoMeta) === null || ref1 === void 0 ? void 0 : ref1.url,
                            $backgroundPosition: (project === null || project === void 0 ? void 0 : project.backgroundPosition) || "center center"
                        }),
                        (project === null || project === void 0 ? void 0 : (ref2 = project.asset) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAsset, {
                            $autoWidth: (project === null || project === void 0 ? void 0 : project.autoWidth) || false,
                            asset: project === null || project === void 0 ? void 0 : project.asset,
                            $backgroundPosition: (project === null || project === void 0 ? void 0 : project.backgroundPosition) || "center center"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                href: (project === null || project === void 0 ? void 0 : project.link) || "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleLine, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    pFormat: "sansRegular52",
                                    children: project === null || project === void 0 ? void 0 : project.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        name: "SkinnyArrow"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRichText/* default */.Z, {
                                pFormat: project === null || project === void 0 ? void 0 : (ref3 = project.styledRichText) === null || ref3 === void 0 ? void 0 : ref3.pFormat,
                                content: project === null || project === void 0 ? void 0 : (ref4 = project.styledRichText) === null || ref4 === void 0 ? void 0 : ref4.body
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ProjectIndexItem_ProjectIndexItem = (ProjectIndexItem);

;// CONCATENATED MODULE: ./components/ProjectIndexItem/index.ts


;// CONCATENATED MODULE: ./blocks/ProjectsIndex/ProjectsIndex.tsx

function ProjectsIndex_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    ProjectsIndex_templateObject = function() {
        return data;
    };
    return data;
}
function ProjectsIndex_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    ProjectsIndex_templateObject1 = function() {
        return data;
    };
    return data;
}
function ProjectsIndex_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 3.25rem;\n  padding-bottom: 1rem;\n"
    ]);
    ProjectsIndex_templateObject2 = function() {
        return data;
    };
    return data;
}
function ProjectsIndex_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr 1fr;\n  "
    ]);
    ProjectsIndex_templateObject3 = function() {
        return data;
    };
    return data;
}
function ProjectsIndex_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 2.5rem;\n    row-gap: 5rem;\n  "
    ]);
    ProjectsIndex_templateObject4 = function() {
        return data;
    };
    return data;
}
function ProjectsIndex_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 80vh;\n  "
    ]);
    ProjectsIndex_templateObject5 = function() {
        return data;
    };
    return data;
}
function ProjectsIndex_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: auto;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.25rem;\n  row-gap: 2.5rem;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    ProjectsIndex_templateObject6 = function() {
        return data;
    };
    return data;
}





const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-edd61565-0"
})(ProjectsIndex_templateObject(), (0,padding/* blockPadV */.zr)(), (0,padding/* blockPadH */.XA)());
const ProjectsIndex_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-edd61565-1"
})(ProjectsIndex_templateObject1(), (0,padding/* blockW */.g5)());
const ProjectTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-edd61565-2"
})(ProjectsIndex_templateObject2());
const ProjectGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-edd61565-3"
})(ProjectsIndex_templateObject6(), (param)=>{
    let { theme  } = param;
    return theme.mq.sm(ProjectsIndex_templateObject3());
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(ProjectsIndex_templateObject4());
}, (param)=>{
    let { theme  } = param;
    return theme.mq.xl(ProjectsIndex_templateObject5());
});
// TODO: eventually this can be a lazy loading container! :o that would be really sweet
const ProjectsIndex = (param)=>{
    let { projects  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProjectsIndex_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectTitle, {
                    children: "Selected Case Studies"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectGrid, {
                    children: projects === null || projects === void 0 ? void 0 : projects.map((project, idx)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProjectIndexItem_ProjectIndexItem, {
                            project: project
                        }, "".concat(idx, "-").concat(project === null || project === void 0 ? void 0 : project.title));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProjectsIndex_ProjectsIndex = (ProjectsIndex);

;// CONCATENATED MODULE: ./blocks/ProjectsIndex/index.ts



/***/ }),

/***/ 3185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GfxImage_GfxImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/GfxImage/GfxImage.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const GfxImage = (param)=>{
    let { layout , quality , src , width =0 , height =0 , objectFit , blurDataURL , placeholder ="empty" , alt , ...rest } = param;
    if (!src) {
        return null;
    }
    const isLayoutFill = layout === "fill";
    const isSvg = src.includes(".svg");
    const imageProps = {
        layout,
        ...rest,
        ...isSvg && {
            unoptimized: true
        },
        ...placeholder === "blur" && {
            blurDataURL: blurDataURL
        },
        ...objectFit !== "none" && {
            style: {
                objectFit
            }
        },
        ...!isLayoutFill && {
            width: width,
            height: height
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: src,
        placeholder: placeholder,
        alt: alt,
        quality: quality,
        ...imageProps
    });
};
/* harmony default export */ var GfxImage_GfxImage = ((0,styled_components_browser_esm/* default */.ZP)(GfxImage).withConfig({
    componentId: "sc-2250b3a7-0"
})(_templateObject()));

;// CONCATENATED MODULE: ./components/GfxImage/index.ts



/***/ }),

/***/ 31585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ StyledRichText_StyledRichText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tinacms/dist/rich-text/index.es.js
var index_es = __webpack_require__(48766);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./components/TinaRichText/TinaRichText.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  li {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}




const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d745d383-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.themeColors.fg;
});
const TinaRichText = (param)=>{
    let { components , content  } = param;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        className: "rich-text",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* TinaMarkdown */.t, {
            content: content,
            components: components
        })
    });
};
/* harmony default export */ var TinaRichText_TinaRichText = (TinaRichText);

;// CONCATENATED MODULE: ./components/TinaRichText/index.ts


// EXTERNAL MODULE: ./components/FormattedText/index.tsx
var FormattedText = __webpack_require__(89867);
;// CONCATENATED MODULE: ./components/StyledRichText/StyledRichText.tsx




const components = (pFormat)=>{
    return {
        p: (props)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                pFormat: pFormat,
                ...props,
                children: props.children
            });
        },
        a: (props)=>{
            var ref;
            const hostname =  true ? window.location.hostname : 0;
            if ((props === null || props === void 0 ? void 0 : props.url) && (props === null || props === void 0 ? void 0 : (ref = props.url) === null || ref === void 0 ? void 0 : ref.indexOf(hostname)) >= 0) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: props === null || props === void 0 ? void 0 : props.url,
                    ...props,
                    children: props.children
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: props === null || props === void 0 ? void 0 : props.url,
                    target: "_blank",
                    rel: "noreferrer",
                    ...props,
                    children: props.children
                });
            }
        }
    };
};
const StyledRichText = (param)=>{
    let { pFormat ="default" , content  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TinaRichText_TinaRichText, {
        components: components(pFormat),
        content: content
    });
};
/* harmony default export */ var StyledRichText_StyledRichText = (StyledRichText);

;// CONCATENATED MODULE: ./components/StyledRichText/index.tsx



/***/ }),

/***/ 54995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14141);
/* harmony import */ var components_GfxImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3185);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    max-height: 100vh;\n    flex: 0; \n    margin: 0 auto;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 0;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        border-radius: ",
        "px;\n      "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  padding: ",
        ";\n  ",
        "\n  ",
        "\n  /* desktop only need >= 0, cause if not we would simply take the border radius from mobile.\nMobile doesn't need it, since if you set mobile to 0, it reads as false and doesnt add border-radius */\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}




const Image = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(components_GfxImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-da1c7ae5-0"
})(_templateObject4(), (param)=>{
    let { $horizontalPaddingMobile  } = param;
    return $horizontalPaddingMobile && "0 1.5rem";
}, (param)=>{
    let { theme , $maxHeightMobile  } = param;
    return $maxHeightMobile && theme.mq.ltLg(_templateObject());
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject1());
}, (param)=>{
    let { theme: { mq  } , mobileborderradius , desktopborderradius  } = param;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject3(), "border-radius: ".concat(mobileborderradius ? mobileborderradius : 16, "px;"), mq.md(_templateObject2(), desktopborderradius ? desktopborderradius : 24));
});
const TinaAsset = (param)=>{
    let { asset , className , ...props } = param;
    // do not render anything if no URL is provided
    if (!asset || !(asset === null || asset === void 0 ? void 0 : asset.src)) {
        return null;
    }
    // We don't want to apply either attribute if both conditions are not met
    const imageBlur = (asset === null || asset === void 0 ? void 0 : asset.placeholder) === "blur" && (asset === null || asset === void 0 ? void 0 : asset.blurDataURL) && {
        placeholder: asset === null || asset === void 0 ? void 0 : asset.placeholder,
        blurDataURL: asset === null || asset === void 0 ? void 0 : asset.blurDataURL
    };
    const imageProps = {
        ...props,
        ...imageBlur
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Image, {
        ...imageProps,
        alt: (asset === null || asset === void 0 ? void 0 : asset.alt) || "image description",
        src: (asset === null || asset === void 0 ? void 0 : asset.src) || "",
        priority: Boolean(asset === null || asset === void 0 ? void 0 : asset.priority),
        quality: (asset === null || asset === void 0 ? void 0 : asset.quality) || 75,
        objectFit: (asset === null || asset === void 0 ? void 0 : asset.objectFit) || "none",
        className: className,
        $horizontalPaddingMobile: (asset === null || asset === void 0 ? void 0 : asset.horizontalPadding) ? true : undefined,
        $maxHeightMobile: (asset === null || asset === void 0 ? void 0 : asset.maxHeightMobile) ? asset === null || asset === void 0 ? void 0 : asset.maxHeightMobile : undefined,
        width: (asset === null || asset === void 0 ? void 0 : asset.width) || 0,
        height: (asset === null || asset === void 0 ? void 0 : asset.height) || 0
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(TinaAsset).withConfig({
    componentId: "sc-da1c7ae5-1"
})(_templateObject5()));


/***/ }),

/***/ 4262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TinaVideo_TinaVideo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/asset_list.json
var asset_list_namespaceObject = JSON.parse('{"K":{"/uploads/cgr-timeline-2.mp4":{"name":"cgr-timeline-2.mp4"},"/uploads/cgr_scroll.mp4":{"name":"cgr_scroll.mp4"},"/uploads/figo-blog.mp4":{"name":"figo-blog.mp4"},"/uploads/figo-cover-compressed.mp4":{"name":"figo-cover-compressed.mp4"},"/uploads/figo-ipad.mp4":{"name":"figo-ipad.mp4"},"/uploads/goodfriend-booking-compressed.mp4":{"name":"goodfriend-booking-compressed.mp4"},"/uploads/goodfriend-calendar-compressed.mp4":{"name":"goodfriend-calendar-compressed.mp4"},"/uploads/goodfriend-map-animation-compressed.mp4":{"name":"goodfriend-map-animation-compressed.mp4"},"/uploads/goodfriend-search-compressed.mp4":{"name":"goodfriend-search-compressed.mp4"},"/uploads/goodfriend-ui-compressed.mp4":{"name":"goodfriend-ui-compressed.mp4"},"/uploads/new_cgr_scroll.mp4":{"name":"new_cgr_scroll.mp4"},"/uploads/overview.mp4":{"name":"overview.mp4"},"/uploads/overview_final.mp4":{"name":"overview_final.mp4"},"/uploads/plume-cover-compressed.mp4":{"name":"plume-cover-compressed.mp4"},"/uploads/plume-laptop-animation-compressed.mp4":{"name":"plume-laptop-animation-compressed.mp4"},"/uploads/plume-page-load-compressed.mp4":{"name":"plume-page-load-compressed.mp4"},"/uploads/plume-shop-compressed.mp4":{"name":"plume-shop-compressed.mp4"}}}');
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./components/TinaVideo/TinaVideo.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-radius: ",
        "px;\n      "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  padding: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}




/* desktop only need >= 0, cause if not we would simply take the border radius from mobile.
Mobile doesn't need it, since if you set mobile to 0, it reads as false and doesnt add border-radius */ const Video = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    componentId: "sc-204519d6-0"
})(_templateObject3(), (param)=>{
    let { $horizontalPaddingMobile  } = param;
    return $horizontalPaddingMobile && "0 1.5rem";
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject());
}, (param)=>{
    let { theme: { mq  } , mobileborderradius , desktopborderradius  } = param;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), "border-radius: ".concat(mobileborderradius || 16, "px;"), mq.md(_templateObject1(), desktopborderradius || 24));
});
const TinaVideo = (param)=>{
    let { src , poster , ...props } = param;
    if (!src) {
        return null;
    }
    // @ts-ignore
    const meta = asset_list_namespaceObject.K[src];
    if (!meta) {
        console.log("run asset meta generator");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
        autoPlay: true,
        loop: true,
        playsInline: true,
        muted: true,
        width: meta.width,
        height: meta.height,
        poster: (poster === null || poster === void 0 ? void 0 : poster.src) || undefined,
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
            src: src
        })
    });
};
/* harmony default export */ var TinaVideo_TinaVideo = (TinaVideo);


/***/ }),

/***/ 48766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ TinaMarkdown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const TinaMarkdown = ({
  content,
  components = {}
}) => {
  if (!content) {
    return null;
  }
  const nodes = Array.isArray(content) ? content : content.children;
  if (!nodes) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes.map((child, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MemoNode, {
      components,
      key: index,
      child
    });
  }));
};
const Leaf = (props) => {
  if (props.bold) {
    const { bold, ...rest } = props;
    if (props.components.bold) {
      const Component = props.components.bold;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("strong", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.italic) {
    const { italic, ...rest } = props;
    if (props.components.italic) {
      const Component = props.components.italic;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("em", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.underline) {
    const { underline, ...rest } = props;
    if (props.components.underline) {
      const Component = props.components.underline;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("u", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.strikethrough) {
    const { strikethrough, ...rest } = props;
    if (props.components.strikethrough) {
      const Component = props.components.strikethrough;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("s", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.code) {
    const { code, ...rest } = props;
    if (props.components.code) {
      const Component = props.components.code;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("code", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.components.text) {
    const Component = props.components.text;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, props.text);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, props.text);
};
const MemoNode = (props) => {
  const MNode = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Node, {
    ...props
  }), [JSON.stringify(props)]);
  return MNode;
};
const Node = ({ components, child }) => {
  const { children, ...props } = child;
  switch (child.type) {
    case "h1":
    case "h2":
    case "h3":
    case "h4":
    case "h5":
    case "h6":
    case "p":
    case "blockquote":
    case "ol":
    case "ul":
    case "li":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        }));
      }
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(child.type, {
        children: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        })
      });
    case "lic":
      if (components.lic) {
        const Component2 = components.lic;
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        }));
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
        components,
        content: child.children
      }));
    case "img":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
        src: child.url,
        alt: child.caption
      });
    case "a":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        }));
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
        href: child.url
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
        components,
        content: children
      }));
    case "code_block":
      const value = child.value;
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("pre", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("code", null, value));
    case "hr":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("hr", null);
    case "break":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null);
    case "text":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        components,
        ...child
      });
    case "mdxJsxTextElement":
    case "mdxJsxFlowElement":
      const Component = components[child.name];
      if (Component) {
        const props2 = child.props ? child.props : {};
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, {
          ...props2
        });
      } else {
        const ComponentMissing = components["component_missing"];
        if (ComponentMissing) {
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentMissing, {
            name: child.name
          });
        } else {
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, `No component provided for ${child.name}`);
        }
      }
    case "maybe_mdx":
      return null;
    case "html":
    case "html_inline":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return child.value;
    case "invalid_markdown":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("pre", null, child.value);
    default:
      if (typeof child.text === "string") {
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
          components,
          ...child
        });
      }
  }
};



/***/ })

}]);